import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
export const api = axios.create({
  baseURL: API_BASE,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// API functions
export const heroAPI = {
  get: () => api.get('/hero'),
  update: (data) => api.put('/admin/hero', data),
};

export const tariffsAPI = {
  getAll: () => api.get('/tariffs'),
  getAllAdmin: () => api.get('/admin/tariffs'),
  create: (data) => api.post('/admin/tariffs', data),
  update: (id, data) => api.put(`/admin/tariffs/${id}`, data),
  delete: (id) => api.delete(`/admin/tariffs/${id}`),
};

export const featuresAPI = {
  getAll: () => api.get('/features'),
  getAllAdmin: () => api.get('/admin/features'),
  create: (data) => api.post('/admin/features', data),
  update: (id, data) => api.put(`/admin/features/${id}`, data),
  delete: (id) => api.delete(`/admin/features/${id}`),
};

export const testimonialsAPI = {
  getAll: () => api.get('/testimonials'),
  getAllAdmin: () => api.get('/admin/testimonials'),
  create: (data) => api.post('/admin/testimonials', data),
  update: (id, data) => api.put(`/admin/testimonials/${id}`, data),
  delete: (id) => api.delete(`/admin/testimonials/${id}`),
};

export const faqAPI = {
  getAll: () => api.get('/faq'),
  getAllAdmin: () => api.get('/admin/faq'),
  create: (data) => api.post('/admin/faq', data),
  update: (id, data) => api.put(`/admin/faq/${id}`, data),
  delete: (id) => api.delete(`/admin/faq/${id}`),
};

export const blogAPI = {
  getAll: () => api.get('/blog'),
  getRecent: (limit = 3) => api.get(`/blog/recent?limit=${limit}`),
  get: (id) => api.get(`/blog/${id}`),
  getAllAdmin: () => api.get('/admin/blog'),
  create: (data) => api.post('/admin/blog', data),
  update: (id, data) => api.put(`/admin/blog/${id}`, data),
  delete: (id) => api.delete(`/admin/blog/${id}`),
};

export const statisticsAPI = {
  getAll: () => api.get('/statistics'),
  getAllAdmin: () => api.get('/admin/statistics'),
  create: (data) => api.post('/admin/statistics', data),
  update: (id, data) => api.put(`/admin/statistics/${id}`, data),
  delete: (id) => api.delete(`/admin/statistics/${id}`),
};

export const partnerAPI = {
  get: () => api.get('/partner-program'),
  update: (data) => api.put('/admin/partner-program', data),
};

export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/admin/settings', data),
};

export const uploadAPI = {
  uploadFile: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/admin/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export const botSettingsAPI = {
  get: () => api.get('/bot-settings'),
  update: (data) => api.put('/admin/bot-settings', data),
};

export const analyticsAPI = {
  trackEvent: (data) => api.post('/analytics/event', data),
  trackVisitor: (data) => api.post('/analytics/visitor', data),
  updateVisitor: (sessionId, data) => api.put(`/analytics/visitor/${sessionId}`, data),
  getStats: () => api.get('/admin/analytics/stats'),
  getTrafficStats: (days = 30) => api.get(`/admin/analytics/traffic?days=${days}`),
  getRecentVisitors: (limit = 50) => api.get(`/admin/analytics/visitors?limit=${limit}`),
  getVisitorDetails: (sessionId) => api.get(`/admin/analytics/visitor/${sessionId}`)
};

export const metadataAPI = {
  get: (pagePath) => api.get(`/metadata/${pagePath}`),
  getAll: () => api.get('/admin/metadata'),
  create: (data) => api.post('/admin/metadata', data),
  update: (id, data) => api.put(`/admin/metadata/${id}`, data),
  delete: (id) => api.delete(`/admin/metadata/${id}`),
};